import { render } from "./edit-employee.vue?vue&type=template&id=22aee160"
import script from "./edit-employee.vue?vue&type=script&lang=js"
export * from "./edit-employee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__